import { makeAutoObservable } from "mobx";
import { RegexPhone } from "./RegexPhone";
/**
 * Observable holder for the consent-withdrawal form's phone input. The field is
 * optional (the user withdraws consent by whichever channel they remember);
 * `PhoneMissing` is reported for an empty value but is not surfaced as an
 * error — at least one contact channel must be provided, which the controller
 * enforces.
 */
export class WithdrawalPhoneModel {
    constructor(initialValue) {
        this.value = "";
        this.value = initialValue;
        makeAutoObservable(this);
    }
    get phone() {
        return RegexPhone.create(this.value);
    }
    get availability() {
        return this.phone.availability;
    }
}
